import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Breadcrumb extends Component {
    render() {
        return (
            <div className="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb pl-0">
                        <li className="breadcrumb-item" style={{marginRight:"10px"}}><Link to="/"><i className="material-icons">home</i> Home</Link></li>
                        <li className="breadcrumb-item"><Link to="/">{this.props.pageprev}</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">{this.props.pagecurrent}</li>
                    </ol>
                </nav>
            </div>
        );
    }
}

export default Breadcrumb;
